export function validateRequired(val) {
  let error;
  if (!val) {
    error = 'fFieldRequired';
  }
  return error;
}

export function validateMinLength(val, minLength) {
  let error;
  if (val.length < minLength) {
    error = 'fMinChar';
  }
  return error;
}

export function validateEmail(val, vals, primaryDriver) {
  let error;
  if (!val) {
    error = 'fFieldRequired';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val)) {
    error = 'fEmailInvalid';
  }
  return error;
}

export function validateEmailNotRequired(val, vals, primaryDriver) {
  let error;
  if (val){
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val)) {
      error = 'fEmailInvalid';
    }
  }
  return error;
}

export function validateEnglishOnly(val) {
  let error;
  if (typeof val === 'string' && !val.trim()) {
    error = 'fFieldRequired';
  }
  return error;
}

export function validateNumbersOnly(val) {
  let error;
  if (!val) {
    error = 'fFieldRequired';
  } else if (!/^[0-9]+$/.test(val)) {
    error = 'fOnlyNumbers';
  }
  return error;
}

export function validateMobileNo(val) {
  let error;
  if (!val) {
    error = 'fFieldRequired';
  } else if (val.startsWith('0')) {
    error = 'fNoLeadingZero';
  } else if (!/^[0-9]+$/.test(val)) {
    error = 'fOnlyNumbers';
  } else if (!/^[0-9]{7,11}$/.test(val)) {
    error = 'fNoNotValid';
  }
  return error;
}

// export function validatePassword(val) {
//   let error;
//   if(!val) {
//     error = 'fFieldRequired';
//   } else if(/\s/.test(val)) {
//     error = 'fPasswordNoSpace';
//   } else if(!/(?=.*[A-Z])/.test(val)) {
//     error = 'fPasswordUppercase';
//   } else if(!/(?=.*[a-z])/.test(val)) {
//     error = 'fPasswordLowercase';
//   } else if(!/(?=.*\d)/.test(val)) {
//     error = 'fPasswordNumber';
//   } else if(!/(?=.*[\^$*.[\]{}()?\-"!@#%&,><':;|_~`\\//])/.test(val)) {
//     error = 'fPasswordSymbol';
//   } else if(!val || !/^[^\s]{8,}$/.test(val)) {
//     error = 'fPassword8Chars';
//   }
//   return error;
// }
export function validatePassword(val) {
  let error = [];
  if (!val) {
    error.push('fFieldRequired');
  }

  if (/\s/.test(val)) {
    error.push('fPasswordNoSpace');
  }

  if (!/(?=.*[A-Z])/.test(val)) {
    error.push('fPasswordUppercase');
  }

  if (!/(?=.*[a-z])/.test(val)) {
    error.push('fPasswordLowercase');
  }

  if (!/(?=.*\d)/.test(val)) {
    error.push('fPasswordNumber');
  }

  if (!/(?=.*[\^$*.[\]{}()?\-"!@#%&,><':;|_~`\\//])/.test(val)) {
    error.push('fPasswordSymbol');
  }

  if (!val || !/^[^\s]{8,}$/.test(val)) {
    error.push('fPassword8Chars');
  }

  if (val && error.length === 0) {
    return undefined;
  }

  return error;
}

export function validateMatchPassword(val, password) {
  let error;
  if (val !== password) {
    error = 'fPasswordNoMatch';
  }
  return error;
}

export function validateChecked(val) {
  let error;
  if (val !== true) {
    error = 'Checkbox must be selected';
  }
  return error;
}

export function validate6Digits(val) {
  let error;
  if (!/^\d{6}$/.test(val)) {
    error = 'fCode6Digits';
  }
  return error;
}

export function validateIC(val, vals, primaryDriver) {
  let error;
  if (vals){
    if ((hasDuplicates(getIcs(removePersonalDriver(vals, primaryDriver))) === val) && val){
      error = 'fDuplicateIc';
    }
  }
  if (!val) {
    error = 'fFieldRequired';
  } else if (!/^[0-9A-Z]{8,12}$/.test(val)) {
    error = 'fICNotValid';
  }

  // else if (!/^[0-9]+$/.test(val)) {
  //   error = 'fOnlyNumbers';
  // } else if (val.length !== 12) {
  //   error = 'fICNotValid';
  // }
  return error;
}

export function validateTshirtName(val, isRaptorEvent) {
  let error;
  if(!isRaptorEvent){
    return error;
  }
  if (typeof val === 'string' && !val.trim()) {
    error = 'fFieldRequired';
  }
  if (val.length > 10) {
    error = 'fMaxChar';
  }
  return error;
}

export function validateHealth(val, vals, healthConfirmStr, isRaptorEvent) {
  let error;
  if(!isRaptorEvent){
    return error;
  }
  if (typeof val === 'string' && !val.trim() && vals[healthConfirmStr] !== true) {
    error = 'fDeclareHealth';
  }
  if (typeof val === 'string' && val.trim() && vals[healthConfirmStr] === true) {
    error = 'fRemoveConfirmHealth';
  }
  return error;
}

export function validateHealthCheckbox(val, vals, healthStr, isRaptorEvent) {
  let error;
  if(!isRaptorEvent){
    return error;
  }
  if (typeof vals[healthStr] === 'string' && !vals[healthStr].trim() && val !== true) {
    error = 'fConfirmHealth';
  }
  return error;
}

function removePersonalDriver(values, isPrimaryDriver){
  var newValues = { ...values};
  delete newValues.agreeLicense;
  if (isPrimaryDriver){
    delete newValues.driver_email;
    delete newValues.driver_ic;
  }
  else{
    delete newValues.email;
    delete newValues.ic;
  }
  return newValues;
}

function getEmails(values){
  var keys = Object.keys(values);
  var newKeys = [];
  var emails = [];
  for (const key of keys){
    if (key.includes('email') || key.includes('Email')){
      newKeys.push(key);
    }
  }
  for (const key of newKeys){
    emails.push(values[key]);
  }
  return emails;
}

function getIcs(values){
  var keys = Object.keys(values);
  var newKeys = [];
  var ics = [];
  for (const key of keys){
    if (key.includes('ic') || key.includes('Ic')){
      newKeys.push(key);
    }
  }
  for (const key of newKeys){
    ics.push(values[key]);
  }
  return ics;
}

function hasDuplicates(array){
  var valuesSoFar = Object.create(null);
  for (var i = 0; i < array.length; ++i) {
    var value = array[i];
    if ((typeof value === 'string') && (value.length > 3)){
      if ((value in valuesSoFar) && (value.length > 3)) {
        return value;
      }
      valuesSoFar[value] = true;
    }
  }
  return false;
}
